import React, { type FC, use, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { FileUploaderContext } from "@dms/modules/DocumentUploader/context/FileUploaderContext";

export const FilesInvalid: FC = () => {
    const { unsupportedFiles } = use(FileUploaderContext);
    const unsupportedValues = useMemo(() => ({ count: unsupportedFiles.length }), [unsupportedFiles.length]);
    if (!unsupportedFiles.length) {
        return null;
    }
    return (
        <div>
            <span className="text-muted">
                <FormattedMessage id="app.dms.upload.unsupportedFiles" values={unsupportedValues} />{" "}
            </span>
            {unsupportedFiles.map((el, i) => {
                return (
                    <div key={i} className="flex justify-between items-center">
                        <span className="text-danger">{el.file.name}</span>
                        <span className="text-warning">{el.reason}</span>
                    </div>
                );
            })}
        </div>
    );
};
